import { TIRES_SCAN_SEARCH_URL } from 'constants/ApiConstants';

import type { ApiError, MetaAction } from 'modules/global/generic.types';
import * as types from 'modules/tireScan/actionTypes';
import type {
  FetchTireScanResponse,
  FetchTireScansAction,
  FetchTireScansFailureAction,
  FetchTireScansPayload,
  FetchTireScansSuccessAction,
} from 'modules/tireScan/types';
import { cleanPayload } from 'utils/RequestUtils';

export const fetchTireScans = (params: FetchTireScansPayload, meta: MetaAction = {}): FetchTireScansAction => ({
  type: types.FETCH_TIRE_SCAN_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: TIRES_SCAN_SEARCH_URL,
      params: cleanPayload(params),
    },
  },
  meta,
});

export const fetchTireScansSuccess = (
  response: FetchTireScanResponse,
  meta: MetaAction = {},
): FetchTireScansSuccessAction => ({
  type: types.FETCH_TIRE_SCAN_SUCCESS,
  payload: response,
  meta,
});

export const fetchTireScansFailure = (error: ApiError, meta: MetaAction = {}): FetchTireScansFailureAction => ({
  type: types.FETCH_TIRE_SCAN_FAILURE,
  payload: error,
  error: true,
  meta,
});
